import { NgModule } from 'ng-metadata/core';
import { FormOrderCancelComponent } from './order-cancel.component';

@NgModule({
  declarations: [FormOrderCancelComponent],
})
export class FormOrderCancelModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/order-cancel/order-cancel.module.ts